module.exports = {"653126100":"喀格勒克镇","653126101":"恰尔巴格镇","653126102":"乌夏巴什镇","653126103":"阿克塔什镇","653126200":"洛克乡","653126201":"伯西热克乡","653126202":"铁提乡","653126203":"恰萨美其特乡","653126204":"吐古其乡","653126205":"江格勒斯乡","653126206":"加依提勒克乡","653126207":"巴仁乡","653126208":"乌吉热克乡","653126209":"夏合甫乡","653126210":"依力克其乡","653126211":"依提木孔乡","653126212":"宗朗乡","653126213":"柯克亚乡","653126214":"西合休乡","653126215":"棋盘乡","653126216":"萨依巴格乡","653126402":"阿克塔什农场","653126403":"良种场","653126405":"林场","653126409":"叶城工业园区","653126500":"兵团叶城牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653126.json
// module id = 3253
// module chunks = 0